
<div class="container">
  <div class="tab-content team">
    <div class="team-container"
         *ngFor="let participant of participants;index as index"
         id="{{participant.original.participant_id}}"
         [ngClass]="{'incomplete': participant.incomplete}">
      <div class="flex_block">
        <img [src]="participant.original.avatar" alt="team_image"/>
        <div class="info">
          <h1>{{participant.original?.participant_name|truncate :participant.truncate}}</h1>
          <div class="flex_block">
            <div class="item">
              <img class="flag"
                   src="assets/img/flags/{{globalService.getCountryAbbr(participant?.original.country)}}.svg"
                   alt="{{participant?.original.country}}">
              <p>{{participant?.original.country}}</p>
            </div>
            <div class="item">
              <svg-icon name="capitain"></svg-icon>
              <p>{{participant?.original?.leader?.username|truncate:20}}</p>
            </div>
          </div>
        </div>
      </div>
      <!--<i class="icon-attention" *ngIf="participant.incomplete"></i>-->

    </div>
  </div>
</div>
